import { AD_SLOT_RENDER_ENDED, adSlotRefresh, AdSlotRenderEndedAction } from 'mk2/containers/AdSlot/AdSlot.actions';
import {
    AD_SLOT_INTERSTITIAL_LOAD_NEXT,
    adSlotInterstitialLoadNext,
    AdSlotInterstitialLoadNextAction,
    adSlotInterstitialPrepared,
} from 'mk2/containers/AdSlotInterstitial/AdSlotInterstitial.actions';
import React from 'react';
import { delay } from 'redux-saga';
import { all, put, takeEvery } from 'redux-saga/effects';

// kolko milisekund cakat, kym sa nacita / pokusi nacitat dalsia reklama
const DELAY_BETWEEN_AD_LOADS = 60 * 1000;

function* loadNext({ slotId, retryCount }: AdSlotInterstitialLoadNextAction) {
    yield delay(DELAY_BETWEEN_AD_LOADS * Math.pow(2, retryCount));  // exponential backoff
    yield put(adSlotRefresh(slotId));
}

function* interstitialRendered({ slotId, event }: AdSlotRenderEndedAction) {
    if (!event.isEmpty) {
        yield put(adSlotInterstitialPrepared());
    } else {
        // wait and then preload next interstitial
        yield put(adSlotInterstitialLoadNext(slotId));
    }
}

export default function* root() {
    yield all([
        takeEvery((action) => action.type === AD_SLOT_RENDER_ENDED && action.slotId.startsWith('mk-interstitial'), interstitialRendered),
        takeEvery(AD_SLOT_INTERSTITIAL_LOAD_NEXT, loadNext),
    ]);
}
